<template lang="pug">
  .absolute.inset-0.flex.justify-center.pointer-events-none(:class="{'items-center': isWider}")
    div(:class="clss", :style="style")
      button.absolute.z-10.bottom-0.right-0.p-6.text-black.hover-text-blue.pointer-events-auto(@click.stop="$emit('click')")
        fullscreen-icon
</template>

<script>
import FullscreenIcon from '@/components/Icons/FullScreenIcon'
export default {
  name: 'CarouselFullscreenBtn',
  props: ['image', 'bgClass'],
  data () {
    return {
      elW: 0,
      elH: 0
    }
  },
  computed: {
    elAR () {
      return this.elH / this.elW
    },
    imgAR () {
      return this.image && this.image.width && this.image.height / this.image.width
    },
    isWider () {
      return this.imgAR < this.elAR
    },
    isCover () {
      return this.bgClass.includes('bg-cover')
    },
    clss () {
      return [
        this.isCover ? 'absolute inset-0' : 'relative',
        this.isWider ? 'w-full' : ''
      ]
    },
    style () {
      if (this.isCover) return
      if (this.isWider) {
        return {
          paddingBottom: `calc(100% * ${this.imgAR})`
        }
      } else {
        return {
          width: `calc(${this.elH} * ${this.image.width} / ${this.image.height} / ${this.elW} * 100%)`
        }
      }
    }
  },
  methods: {
    measure () {
      if (this.isCover) return
      this.elW = this.$el.offsetWidth
      this.elH = this.$el.offsetHeight
    }
  },
  mounted () {
    this.measure()
  },
  components: {
    FullscreenIcon
  }
}
</script>

<style>
</style>
